<form [formGroup]="socialMediaForm" (ngSubmit)="saveSocialMedia(inProgress)">
    <div class=" modal-header">
        <h5 class="modal-title d-flex align-items-center">
            <i class="ri-chat-history-line me-1 font-20 text-primary"></i>{{socialMediaForm.value.id?'Update':'Add'}}
            Social Media
        </h5>
        <button type="button" class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close"
            (click)="activeModal.close('Close')"></button>
    </div>
    <div class="modal-body">
        <div class="row g-3">
            <div class="col-md-6" formGroupName="social">
                <label for="type" class="form-label">Social Media <b class="text-secondary">*</b></label>
                <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0"><i class='bx bxs-grid-alt'></i></span>
                    <ng-select class="form-control rcx-ng-select" formControlName="id" placeholder="Select a platform" ngbAutofocus
                        [ngClass]="{'is-invalid': submitted && g.controls.id.errors}" [clearable]="false">
                        <ng-option *ngFor="let media of socialMedias;" [value]="media.id">{{media.name}}</ng-option>
                    </ng-select>
                    <div class="invalid-feedback" *ngIf="submitted && g.controls.id.errors">
                        <span *ngIf="g.controls.id.errors.required">Please select a social media.</span>
                        <span *ngIf="g.controls.id.errors.pattern">Only letters are allowed.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <label for="link" class="form-label">Link <b class="text-secondary">*</b></label>
                <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                            class='bx bx-link'></i></span>
                    <input type="text" class="form-control ps-1" id="link" placeholder="Enter link"
                        [ngClass]="{'is-invalid': submitted && f.link.errors}" formControlName="link"
                        autocomplete="off" />
                    <div class="invalid-feedback" *ngIf="submitted && f.link.errors">
                        <span *ngIf="f.link.errors.required ||f.link.errors.pattern">Please enter a valid link.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <label for="handle" class="form-label">Account Handler <b class="text-secondary">*</b></label>
                <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                            class='bx bx-move'></i></span>
                    <input type="text" class="form-control ps-1" id="handle" placeholder="Enter account handler"
                        [ngClass]="{'is-invalid': submitted && f.handle.errors}" formControlName="handle"
                        autocomplete="off" />
                    <div class="invalid-feedback" *ngIf="submitted && f.handle.errors">
                        <span *ngIf="f.handle.errors.required">Please enter a valid handle.</span>
                        <span *ngIf="f.handle.errors.pattern">Only letters are allowed.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-auto">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="disabled" formControlName="disabled">
                    <label class="form-check-label" for="disabled">Disabled</label>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-light" (click)="activeModal.close('Close')"><i
                class="bx bx-x"></i>Close</button>
        <button type="submit" class="btn btn-secondary" #inProgress [ngClass]="{'no-event':inProgress?.value=='true'}">
            <ng-container *ngIf="inProgress?.value=='true'">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                {{socialMediaForm.value.id?'Updating...':'Saving...'}}
            </ng-container>
            <ng-container *ngIf="inProgress?.value!='true'">
                <i class="bx bx-save"></i>{{socialMediaForm.value.id?'Save Changes':'Save'}}
            </ng-container>
        </button>
    </div>
</form>